import { styled } from '../config'

function Svg(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M2 3.5C2 2.67157 2.67157 2 3.5 2H16.5C17.3284 2 18 2.67157 18 3.5V8C17.4477 8 17 8.44772 17 9C17 9.55228 17.4477 10 18 10V16.5C18 17.3284 17.3284 18 16.5 18H3.5C2.67157 18 2 17.3284 2 16.5V10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8V3.5Z"
        fill=""
      />

      <circle cx="7" cy="6" r="1" fill="white" opacity="0.9" />
      <circle cx="13" cy="12.5" r="1" fill="white" opacity="0.9" />

      <line
        x1="6"
        y1="13"
        x2="14"
        y2="5"
        stroke="white"
        strokeWidth="1.5"
        opacity="0.9"
      />
    </svg>
  )
}

export const Promotions = styled(Svg)
